export const hackathonProjects = [
  {
    title: "FitQuest - DeltaHacks",
    features: [
      "Computer Vision Tracking: OpenCV monitors and ensures proper workout form.",
      "Real-Time Exercise Counting: Automatically counts repetitions and tracks workout performance.",
      "Dynamic Leaderboard: Real-time updates of user rankings based on completed exercises and points."
    ],
    techStack: ["Python", "OpenCV", "HTML", "CSS"],
    images: [
      "/hackathon_project_images/fitquest-1.png"
    ],
    links: {
      github: "https://github.com/Anahat07/FitQuest",
      devpost: "https://devpost.com/software/fitquest-7a4xju"
    }
  },
  {
    title: "DeBlizzard - ElleHacks",
    features: ["Google Maps API Integration: Allows users to view and book available volunteers in their area, with real-time mapping and location tracking.",
      "User-Friendly Interface: Designed with HTML, CSS, and JavaScript for a seamless and intuitive experience on both the website and app prototype.",
      "Real-Time Tracking: Monitors and displays the progress of snow removal tasks in real time for users and volunteers."],
    techStack: ["HTML", "CSS", "JavaScript, Google Maps API", "Marvel Prototyping"],
    images: ["/hackathon_project_images/deblizzard-1.png",
      "/hackathon_project_images/deblizzard-2.png",
      "/hackathon_project_images/deblizzard-3.png",
      "/hackathon_project_images/deblizzard-4.png",
      "/hackathon_project_images/deblizzard-5.png",
      "/hackathon_project_images/deblizzard-6.png",
    ],
    links: {
      github: "https://github.com/Anahat07/DeBlizzard",
      devpost: "https://devpost.com/software/deblizzard"
    }
  },
  {
    title: "Solarise - HawkHacks",
    features: [
      "Google Maps Solar API Integration: Provides personalized solar panel recommendations, including potential panel placement and annual sunshine data.",
      "Interactive Games for Kids: Role-playing and scenario-based games designed with HTML, CSS, and JavaScript to teach energy efficiency concepts.",
      "AI Chatbot 'Beamy': Powered by the OpenAI API to answer user questions and provide additional information on energy efficiency and solar panels."
    ],
    techStack: ["HTML", "CSS", "JavaScript", "Node.js", "OpenAI API", "Google Maps API", "Google Solar API"],
    images: ["/hackathon_project_images/solarise-1.png",
      "/hackathon_project_images/solarise-2.png",
      "/hackathon_project_images/solarise-3.png",
      "/hackathon_project_images/solarise-4.png",
      "/hackathon_project_images/solarise-5.png",
      "/hackathon_project_images/solarise-6.png",
    ],
    links: {
      github: "https://github.com/Anahat07/Solarise",
      devpost: "https://taikai.network/hackbox/hackathons/hawkhacks/projects/clwdkc41r0f3suc01ukrm0cmw/idea"
    }
  },
  {
    title: "BudgetBites - EWB Moral Code",
    features: ["Google Chrome Extension Integration: Provides users with discount codes as they browse grocery store websites in real-time.",
      "Personalized Coupon and Recipe Generator: Curates shopping experiences by offering tailored coupons and generating recipes based on user preferences and available ingredients.",
      "Mobile-Friendly Design: Built using Bootstrap to ensure easy accessibility and seamless browsing on mobile devices.",
      "Google Chrome Extension: Automatically provides real-time discount codes for healthy food items while users browse grocery store websites, streamlining savings through Chrome Extensions API integration."],
    techStack: ["HTML", "CSS", "JavaScript", "Chrome Extension"],
    images: ["/hackathon_project_images/budgetbites-1.png",
      "/hackathon_project_images/budgetbites-2.png",
      "/hackathon_project_images/budgetbites-3.png"
    ],
    links: {
      github: "https://github.com/Anahat07/BudgetBites",
      website: "https://drive.google.com/file/d/1hGoxEAZxdoNydfPC5D4T8ZGZIR-wA068/view",
      demo: "https://drive.google.com/file/d/1iJ0l4zLRdTxNOFJd5irDw9XgyyE0WZNh/view"
    }
  },
  {
    title: "SafeNest - Technova",
    features: ["Personalized Roadmaps: Customizable financial independence plans tailored to each user's journey.",
      "Secure Financial Management Tools: Link bank accounts, track finances, and set personalized financial goals.",
      "AI-Driven Support Chatbot: Provides real-time guidance, emotional support, and personalized resources.",
      "Confidential & Secure Environment: Built with PropelAuth for secure user authentication and privacy."],
    techStack: ["React", "Tailwind CSS", "PropelAuth", "OpenAI API", "Node.js"],
    images: ["/hackathon_project_images/safenest-1.png",
      "/hackathon_project_images/safenest-2.png",
      "/hackathon_project_images/safenest-3.png",
      "/hackathon_project_images/safenest-4.png"
    ],
    links: {
      github: "https://github.com/Anahat07/safenest",
      devpost: "https://devpost.com/software/safenest-k4lr5f?ref_content=my-projects-tab&ref_feature=my_projects",
      demo: "https://drive.google.com/file/d/1LEeix1RDdDK9PqoOr0_ENGyB_ytmvffb/view"
    }
  },
  {
    title: "Hardware Hack - Hack The North",
    features: ["Autonomous Driving System with line-following capability for hands-free navigation.",
      "Object Recognition Integration enabling the robot to detect and respond to real-world obstacles.",
      "Voice-Controlled Commands allowing users to direct the robot through natural speech.",
      "Python-Powered Development using multiple libraries to control sensors, motors, and APIs on a Raspberry Pi.",
      "Hardware-Software Integration combining wiring, microSD setup, and wireless connectivity for a fully functional prototype.",
      "Hackathon Innovation built under tight time constraints at Canada’s largest hackathon, overcoming steep learning curves in hardware and APIs.",
      "Collaborative Problem-Solving gained first-hand experience in teamwork, rapid prototyping, and adapting to unexpected challenges."],
    techStack: ["Rasberry Pi", "Python", "OpenCV", "API Integration"],
    images: ["/hackathon_project_images/htn1.jpeg",
      "/hackathon_project_images/htn2.jpeg"
    ],
    links: {
      demo: "https://www.linkedin.com/posts/activity-7242155502434971648-UNR5?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD3YDd0B-QeS1JqgsgeHV5FzjoDrw2-ZbaY"
    }
  },
  {
  title: "Puck Yeah! - Technova",
  features: [
    "Full-Stack Web App: Provides fans of the PWHL with a fantasy league experience, spotlighting women’s hockey.",
    "User Authentication & League Management: Includes dashboards, team views, and a player draft engine.",
    "Real-Time Stats & AI Commentary: Pulls PWHL statistics via REST APIs with Axios and integrates an AI commentator using Google Gemini API.",
    "Front-End Routing & UI Enhancements: Managed with React Router and enhanced with Lucide Icons.",
    "Database & Authentication: Structured using MongoDB with Mongoose, implemented JWT-based authentication, and deployed via Render.",
    "Hackathon Experience: First full-stack project for the team, gained hands-on experience connecting front and back end, debugging APIs, and structuring scalable databases under hackathon time constraints."
  ],
  techStack: ["React", "Express.js", "MongoDB", "Mongoose", "JWT Authentication", "Axios", "Lucide Icons", "Render", "Google Gemini API"],
  images: [
    "/hackathon_project_images/puckyeah1.png",
    "/hackathon_project_images/puckyeah2.png",
    "/hackathon_project_images/puckyeah3.png",
    "/hackathon_project_images/puckyeah4.png",
    "/hackathon_project_images/puckyeah5.png",
    "/hackathon_project_images/puckyeah6.png"
  ],
  links: {
    devpost: "https://devpost.com/software/puck-yeah",
    demo: "https://youtu.be/-hbunjvI9Vs?si=lRnu-EUATWWpa5Hn", 
    website: "https://puckyeah.tech/" 
  }
}
];